import { render } from "./ListPenyedia.vue?vue&type=template&id=26148364"
import script from "./ListPenyedia.vue?vue&type=script&lang=js"
export * from "./ListPenyedia.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__